//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { openWordStudy } from '@/utils/openWordStudy'
export default {
  data () {
    return {
      form: { anchor_name: '', word: '', word_text: '', word_id: null, word_meaning: '' },
      keyword: '',
      words: [],
      saving: false
    }
  },
  created () {
    this.$ajax.get(this.$api.mpAnchorDetail + '?id=' + this.$route.query.id).then(r => {
      if (!r) return
      this.form = {
        anchor_name: r.anchor_name || r.anchorName || '',
        word: r.word || r.word_text || r.wordText || '',
        word_text: r.word || r.word_text || r.wordText || '',
        word_id: r.word_id || r.wordId || null,
        word_meaning: r.word_meaning || r.meaning || ''
      }
    })
  },
  methods: {
    goBack () {
      const pid = this.$route.query.palace_id
      if (pid) {
        this.$router.replace({ path: '/mpDetail_display', query: { id: pid, hideTrans: 'true' } })
      } else {
        this.$router.replace({ path: '/mpHome_display', query: { hideTrans: 'true' } })
      }
    },
    search () {
      if (!this.keyword) { this.words = []; return }
      this.$ajax.get(this.$api.mpWordSearch + '?keyword=' + encodeURIComponent(this.keyword)).then(r => {
        this.words = r || []
      })
    },
    pick (w) {
      this.form.word_id = w.word_id
      this.form.word = w.word
      this.form.word_text = w.word
      this.form.word_meaning = w.meaning
      this.words = []
      this.keyword = ''
    },
    unbind () {
      this.form.word_id = null
      this.form.word = ''
      this.form.word_text = ''
      this.form.word_meaning = ''
    },
    studyWord () {
      openWordStudy(this.$router, this.form.word || this.form.word_text)
    },
    save () {
      this.saving = true
      this.$ajax.post(this.$api.mpAnchorUpdate, {
        id: this.$route.query.id,
        anchor_name: this.form.anchor_name,
        word_id: this.form.word_id,
        word_text: this.form.word || this.form.word_text
      }).then(() => {
        this.$toast && this.$toast('已保存')
        this.goBack()
      }).catch(e => {
        this.$toast && this.$toast(e.message || '保存失败')
      }).finally(() => { this.saving = false })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/memory-palace/anchor-edit.vue